module.exports = __webpack_public_path__ + "static/media/tieto-evry-logo.35fec61d.svg";